import * as React from 'react';

import classnames from 'classnames';

import './style.scss';

interface Props {
    children: any;
    id?:string;
    className?: string;
    serif?: boolean;
    center?: boolean;
}

export class H4 extends React.PureComponent<Props> {
    render() {

        let classes = classnames(this.props.className, {
            'serif': this.props.serif,
            'center': this.props.center,
        });

        return (

            <h4 id={this.props.id} className={classes}>
                { this.props.children }
            </h4>
        )
    }
}
